import React, { createContext, useContext, useState } from 'react';
import { getUnitPrice } from '../data/products';

const CartContext = createContext();

export const CartProvider = ({ children }) => {
  const [cart, setCart] = useState([]);
  const [isDiscountApplied, setIsDiscountApplied] = useState(false);

  const calculateItemPrice = (item) => {
    if (item.variant) return item.variant.price;
    return getUnitPrice(item.basePrice, item.quantity, item.isSubscription, item.subPrice);
  };

  const addToCart = (product, quantity = 1, isSubscription = false, variant = null) => {
    setCart((previous) => {
      const variantId = variant ? variant.id : 'default';
      const cartKey = `${product.id}-${variantId}-${isSubscription ? 'sub' : 'one-time'}`;
      const existing = previous.find((item) => item.cartKey === cartKey);
      const updated = existing
        ? previous.map((item) => item.cartKey === cartKey
          ? { ...item, quantity: item.quantity + quantity }
          : item)
        : [...previous, {
          ...product,
          basePrice: product.price,
          quantity,
          isSubscription,
          cartKey,
          variant
        }];

      return updated.map((item) => ({ ...item, price: calculateItemPrice(item) }));
    });
  };

  const removeFromCart = (cartKey) => {
    setCart((previous) => previous.filter((item) => item.cartKey !== cartKey));
  };

  const updateQuantity = (cartKey, delta) => {
    setCart((previous) => previous.map((item) => {
      if (item.cartKey !== cartKey) return item;
      const updatedItem = { ...item, quantity: Math.max(1, item.quantity + delta) };
      return { ...updatedItem, price: calculateItemPrice(updatedItem) };
    }));
  };

  const subtotal = cart.reduce((sum, item) => sum + item.price * item.quantity, 0);

  const applyDiscount = (code) => {
    if (code.toUpperCase() !== 'UBEA15') return false;
    setIsDiscountApplied(true);
    return true;
  };

  return (
    <CartContext.Provider
      value={{
        cart,
        addToCart,
        removeFromCart,
        updateQuantity,
        subtotal,
        applyDiscount,
        isDiscountApplied
      }}
    >
      {children}
    </CartContext.Provider>
  );
};

export const useCart = () => useContext(CartContext);